import {
  getCandidateDocumentToManageQuery,
  getCandidatePageInfoQuery,
  getCandidatesListQuery,
  getCurrentUserCandidateInfoQuery,
  getOriginalDocumentFileQuery,
  FileDTO,
  purgeDriverMutation,
  updateDriverMutation,
} from './interfaces';
import {
  apiService,
  candidatesListTag,
  candidateDocumentsListTag,
  currentDriverInfoTag,
  documentReviewTag,
} from '../api';

const candidateService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getCandidatesList: builder.query<
      getCandidatesListQuery['response'],
      getCandidatesListQuery['request']
    >({
      query: ({ query }) => ({
        url: `/driver-info/document-collection-app/search${
          query ? `?${query}` : ''
        }`,
        method: 'GET',
      }),
      providesTags: [{ type: candidatesListTag }],
    }),
    getCandidatePageInfo: builder.query<
      getCandidatePageInfoQuery['response'],
      getCandidatePageInfoQuery['request']
    >({
      query: ({ candidateId }) => ({
        url: `/document-request/manager/candidate-page-info/${candidateId}`,
        method: 'GET',
      }),
      providesTags: [
        { type: candidateDocumentsListTag },
        { type: documentReviewTag },
      ],
    }),
    getCurrentUserCandidateInfo: builder.query<
      getCurrentUserCandidateInfoQuery['response'],
      void
    >({
      query: () => ({
        url: `/driver-info/me`,
        method: 'GET',
      }),
      providesTags: [{ type: currentDriverInfoTag }],
    }),
    getDocumentToManage: builder.query<
      getCandidateDocumentToManageQuery['response'],
      getCandidateDocumentToManageQuery['request']
    >({
      query: ({ candidateDocumentId }) => ({
        url: `/document-request/manager/candidate-document-to-manage/${candidateDocumentId}`,
        method: 'GET',
      }),
      providesTags: [{ type: candidateDocumentsListTag }],
    }),
    getOriginalDocumentFile: builder.query<
      getOriginalDocumentFileQuery['response'],
      getOriginalDocumentFileQuery['request']
    >({
      async queryFn(
        { candidateDocumentId, fileName },
        _api,
        _extraOptions,
        baseQuery
      ) {
        const result = await baseQuery({
          url: `document-request/manager/original-document-file/${candidateDocumentId}/${fileName}`,
          method: 'GET',
        });

        if (result.error) {
          return { data: { url: '' } };
        }
        return { data: result.data as FileDTO };
      },
    }),
    updateDriver: builder.mutation<
      updateDriverMutation['response'],
      updateDriverMutation['request']
    >({
      query: ({ candidateId, ...body }) => ({
        url: `/driver-info/update/${candidateId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [
        { type: candidateDocumentsListTag },
        { type: candidatesListTag },
        { type: documentReviewTag },
      ],
    }),
    purgeDriver: builder.mutation<
      purgeDriverMutation['response'],
      purgeDriverMutation['request']
    >({
      query: ({ candidateId }) => ({
        url: `/document-request/manager/candidate-requests/${candidateId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [
        { type: candidateDocumentsListTag },
        { type: candidatesListTag },
      ],
    }),
  }),
});

export default candidateService;
